import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme) => ({
  deviceTitle: {
    marginBottom: 16,
    color: "#465869",
    font: "700 18px/18px Manrope",
  },
  deviceSelect: {
    marginBottom: 16,
  },
  progressSection: {
    display: "flex",
    alignItems: "center",
  },
  progressSectionTitle: {
    color: "#465869",
    font: "500 14px/24px Manrope",
    marginRight: 24,
  },
  progress: {
    backgroundColor: "#38CFC4 !important",
    borderRadius: 4,
  },
  background: {
    borderRadius: 4,
  },
}));

export default styles;
